exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-box[data-v-28c7d3b3]{border-top:6px solid #f6f7f9}.title-tips[data-v-28c7d3b3]{height:38px;line-height:38px;color:#999;font-size:12px}.title-bar[data-v-28c7d3b3]{padding:20px 0 0 15px;color:#333;font-size:14px;font-family:PingFang SC-Regular,PingFang SC;font-weight:400;position:relative}", ""]);

// exports
